/* unplugin-vue-components disabled */import { render } from "./UserAgreement.vue?vue&type=template&id=4c1a8736&scoped=true"
import script from "./UserAgreement.vue?vue&type=script&lang=js"
export * from "./UserAgreement.vue?vue&type=script&lang=js"

import "./UserAgreement.vue?vue&type=style&index=0&id=4c1a8736&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/mianjuyry-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1a8736"]])

export default __exports__